import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

import {
  ref, toRefs, Ref, computed, watchEffect,
} from 'vue';
import { Account, AccountPresenter } from '@/models';
import { AccountAddress } from '@/utils';
import { fetchAccount } from '@/api';


export default /*#__PURE__*/_defineComponent({
  props: {
    address: null
  },
  setup(__props: any) {

const props = __props as {
  address: AccountAddress,
}



const { address } = toRefs(props);
const loading = ref(false);
const account: Ref<Account | null> = ref(null);
const presenter: Ref<AccountPresenter | null> = ref(null);
const state = computed(() => {
  if (loading.value) return 'loading';
  if (account.value) return 'success';
  return 'error';
});

const fetch = async () => {
  try {
    loading.value = true;
    account.value = await fetchAccount(address.value);
    presenter.value = account.value ? new AccountPresenter(account.value) : null;
    // TODO: Handle null but recognised accounts like System Program which would be displayed as "Account Not Found" right now.
  } finally {
    loading.value = false;
  }
};

const scope = computed(() => ({
  loading: loading.value,
  account: account.value,
  presenter: presenter.value,
  state: state.value,
  fetch,
}));

watchEffect(fetch);

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(scope))), () => [
    (_unref(state) === 'loading')
      ? _renderSlot(_ctx.$slots, "loading", _normalizeProps(_mergeProps({ key: 0 }, _unref(scope))))
      : (_unref(state) === 'success')
        ? _renderSlot(_ctx.$slots, "success", _normalizeProps(_mergeProps({ key: 1 }, _unref(scope))))
        : _renderSlot(_ctx.$slots, "error", _normalizeProps(_mergeProps({ key: 2 }, _unref(scope))))
  ])
}
}

})